import { Popover } from 'foundations-components/transitional/components/Popover';
import { useCallback, useState } from 'react';
import { UPDATE_LINK } from 'rich-text-lib/constants/usageTracking';
import LinkForm from '../../../draft-transplant/components/LinkForm';
import { encodeUrl, ensureUrlHasProtocol } from '../../../draft-transplant/utils/libUtils';
import { Tracker } from '../../../utils/usageTracker';
import { PM_LINK } from '../../constants/events';
import { FocusPlugin } from '../FocusPlugin';
import { LinkPlugin, initialState } from './LinkPlugin';
import { makeLinkNode } from './LinkUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LinkContent(props) {
  const {
    markBounds,
    editorView,
    initialText,
    initialHref,
    initialTarget,
    target,
    paymentLinkReferrer
  } = props;
  const [text, setText] = useState(initialText || '');
  const [href, setHref] = useState(initialHref || '');
  const [isTargetBlank, setTargetBlank] = useState(initialTarget);
  const onSave = useCallback(() => {
    const {
      state
    } = editorView;
    const encodedUrl = encodeUrl(ensureUrlHasProtocol(href));
    const linkNode = makeLinkNode(state.schema, encodedUrl, text, isTargetBlank, false, state.selection.$from.marks());
    const tr = state.tr.replaceRangeWith(markBounds.from, markBounds.to, linkNode).setMeta(FocusPlugin, {
      focusView: true
    });
    editorView.dispatch(tr);
    Tracker.track(PM_LINK, {
      action: UPDATE_LINK,
      externalLink: isTargetBlank,
      isImage: false,
      noFollow: false,
      isPaymentLink: encodedUrl === null || encodedUrl === void 0 ? void 0 : encodedUrl.includes(`referrer=${paymentLinkReferrer}`)
    });
  }, [text, markBounds, editorView, href, isTargetBlank, paymentLinkReferrer]);
  const onLinkChange = useCallback(params => {
    if (params.url !== undefined) setHref(params.url);
    if (params.text !== undefined) setText(params.text);
    if (params.isTargetBlank !== undefined) setTargetBlank(params.isTargetBlank);
  }, []);
  const onLinkRemove = useCallback(() => {
    let tr = editorView.state.tr;
    const {
      schema
    } = editorView.state;
    tr = tr.removeMark(markBounds.from, markBounds.to, schema.marks.link);
    editorView.dispatch(tr);
  }, [markBounds, editorView]);
  const onCancel = useCallback(() => {
    let tr = editorView.state.tr;
    tr = tr.setMeta(LinkPlugin, initialState);
    editorView.dispatch(tr);
  }, [editorView]);
  return /*#__PURE__*/_jsx(Popover, {
    open: true,
    content: /*#__PURE__*/_jsx(LinkForm, {
      isNew: false,
      text: text,
      url: href,
      isTargetBlank: isTargetBlank,
      isNoFollow: true,
      onChange: onLinkChange,
      onConfirm: onSave,
      onCancel: onCancel,
      onRemove: onLinkRemove,
      hideNoFollowConfiguration: true
    }),
    target: target
  });
}